import React, { useState } from "react";
import { Redirect, useLocation } from "react-router-dom";

/*
* @component
* HOC перенаправляет пользователя на страницу со списком записей, после добавления или обновления
* */
export const RedirectAfterSubmitForm = (Component) => {
  const FormComponent = (props) => {
    const [redirect, setRedirect] = useState(false);
    let listView = props.redirectTo;
    if (!listView){
      const location = useLocation();
      let params = location.pathname.split('/').filter(i => i.length > 0);
      const last = params[params.length - 1];
      if (last === 'create' || !isNaN(last)){
        params = params.slice(0, -1);
      }
      listView = '/' + params.join('/') + '/';
    }

    const handleSubmit = (formData) => {
      props.onSubmit(formData);
      setRedirect(true);
    };

    if (redirect) return <Redirect to={ listView }/>
    return <Component {...props} onSubmit={ handleSubmit }/>
  }


  return FormComponent;
}
